import {Component} from 'panel';

import template from './index.jade';
// imported in auth-container
// import './index.styl';

export class AuthFooter extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      'show-footer-links': `boolean`,
    };
  }
  get config() {
    return {
      template,
    };
  }
}

customElements.define(`auth-footer`, AuthFooter);
